import _classCallCheck from "D:\\SwaShakthiSHGHost\\SwaShakthi-Software\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
export var EmailJSResponseStatus = function EmailJSResponseStatus(httpResponse) {
  _classCallCheck(this, EmailJSResponseStatus);

  this.status = httpResponse ? httpResponse.status : 0;
  this.text = httpResponse ? httpResponse.responseText : 'Network Error';
};